/**
 * internal dependencies
 */
import { showToast } from "../toasts";
import { getCardListData } from './data/get-cardlist';
import { displayCardListTable } from './display/display-cardlist';
import { cardListTableFilter } from './filters/cardlist-filter';
import { downloadCardListData } from './download/cardlist-download';


/**
 * Card List Table Main
 * This function initializes and manages the card list table and related functionalities.
 * 
 * @returns void
 */
const CardListTable = async (): Promise<void> => {
  const cardListTable = document.querySelector('.aafp_card-list') as HTMLElement;
  if(!cardListTable) return;

  const cardListData = await getCardListData();
  
  if (cardListData.length === 0) {
    showToast("aafp_toast-alert", "Error fetching card list data. Please try again later.");
    return;
  }

  const tableObject = displayCardListTable(cardListTable, cardListData);
  cardListTableFilter(tableObject);
  downloadCardListData(tableObject);
};

export default CardListTable;